import {
  createTheme,
  genPageTheme,
  lightTheme,
  shapes,
} from '@backstage/theme';

const color = '#05164d';

// docs: https://backstage.io/docs/getting-started/app-custom-theme/
export const customTheme = createTheme({
  palette: {
    ...lightTheme.palette,
    primary: {
      main: color,
    },
    banner: {
      info: '#34548a',
      error: '#8c4351',
      text: color,
      link: '#565a6e',
    },
    navigation: {
      background: color,
      indicator: color,
      color: '#ffffff',
      selectedColor: '#1dd5c7',
      navItem: {
        hoverBackground: '#1dd5c7',
      },
    },
  },
  defaultPageTheme: 'home',
  /* below drives the header colors */
  pageTheme: {
    home: genPageTheme({ colors: [color], shape: shapes.wave }),
    documentation: genPageTheme({ colors: [color], shape: shapes.wave }),
    tool: genPageTheme({ colors: [color], shape: shapes.wave }),
    service: genPageTheme({ colors: [color], shape: shapes.wave }),
    website: genPageTheme({ colors: [color], shape: shapes.wave }),
    library: genPageTheme({ colors: [color], shape: shapes.wave }),
    other: genPageTheme({ colors: [color], shape: shapes.wave }),
    app: genPageTheme({ colors: [color], shape: shapes.wave }),
    apis: genPageTheme({ colors: [color], shape: shapes.wave }),
  },
});
